import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class ViewProfile extends React.Component {
    _isMounted = false;
    state = {
        AllRoles: [],
        deleteAllProfile: false,
        readOnly: false,
        alert: 0,
        alertMessage: '',
        flag: true,
        showAddEdit: true,
        ProfileUniqeID: this.props.UniqeID ? this.props.UniqeID : null,
        FullName: '',
        DateOfBirth: '',
        EmailId: '',
        RegionalLanguage: '',
        PhoneNumber: '',
        SecondaryPhoneNumber: '',
        WhatsAppNumber: '',
        Education: '',
        Profession: '',
        PanNumber: '',
        AadharNumber: '',
        BankName: '',
        AccountNumber: '',
        AccountHolderName: '',
        IFSCCode: '',
        AccountType: '',
        HouseNumber: '',
        Area: '',
        City: '',
        District: '',
        PinCode: '',
        State: '',
        
        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: '',
        profileDocId: '',
        Beneficiary: [],
        primaryBank: '',
        addNewBank: false,
        NewBankVerified: false,
        NewPanNumber: '',
        NewBankName: '',
        NewAccountNumber: '',
        NewAccountHolderName: '',
        NewIFSCCode: '',
        NewAccountType: '',
        NewPhoneNumber: '',
        NewBankVerified: false,
        NewEmailId: '',
        NewBankDetails: [],

        maxDOB: this.getMaxDOB(),
        ValidateBankAccount: false,
        AllRegionalLanguage: [
            'Bengali',
            'English',
            'Gujarati',
            'Hindi',
            'Kannada',
            'Malayalam',
            'Marathi',
            'Oriya',
            'Punjabi',
            'Telugu'
        ],
        AllProfessions: [
            'CSC Center',
            'Money Transfer Point',
            'Fancy Shop',
            'Super Market',
            'Electronics Store',
            'Home Appliances Store',
            'Clothes Store',
            'Xerox Store',
            'Others'
        ],
        
        AvaliableStoreTags: [],
        AllStates: [
            'Andhra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Andaman and Nicobar Islands',
            'Bihar',
            'Chandigarh',
            'Chhattisgarh',
            'Delhi',
            'Dadra and Nagar Haveli and Daman and Diu',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu and Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Ladakh',
            'Lakshadweep',
            'Madhya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Odisha',
            'Punjab',
            'Puducherry',
            'Rajasthan',
            'Sikkim',
            'Tamil Nadu',
            'Telangana',
            'Tripura',
            'Uttar Pradesh',
            'Uttarakhand',
            'West Bengal'
        ]
    };

    getMaxDOB() {
        var today = new Date();

        var MM = String(today.getMonth() + 1).padStart(2, '0');
        var DD = String(today.getDate()).padStart(2, '0');
        var date = today.getFullYear() - 15 + '-' + DD + '-' + MM;
        return date;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        
        if (this.props.UniqeID) {
            this.setState({ readOnly: true });
            this.getProfileDetail();
        } else {
            this.setState({ flag: false });
        }
    }

    async getProfileDetail() {
        let dataRow = {
            UniqeID: this.props.UniqeID,
            UserRole: this.props.selectedUserRole
        };
       
        await RestServices.getProfileDetail(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData) {
                        this.setState({
                            AllRoles: responseData.Roles,
                            flag: false
                        });
                        if (this._isMounted) {
                            this.setState({
                                ...this.fieldsMapUtil(responseData.data),
                                Beneficiary: responseData.data.Beneficiary
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    fieldsMapUtil = (data) => {
        let res = {};
        Object.keys(data).forEach((val) => {
            res = { ...res, [val]: data[val] };
        });
        res = {
            ...res,
            oldAccountNumber: data.AccountNumber,
            oldAccountHolderName: data.AccountHolderName,
            oldBankName: data.BankName,
            oldIFSCCode: data.IFSCCode,
            oldPanNumber: data.PanNumber,
            oldPhoneNumber: data.PhoneNumber,
            OldStatus:data.Status,
            LastUpdatedTimeStamp: data.LastUpdatedTimeStamp,
            UpdatedBy: data.UpdatedBy,
            RequestedTimeStamp: data.RequestedTimeStamp
        };
        return res;
    };

    editProfileData = () => {
        let data = {
            UniqeID: this.state.ProfileUniqeID,
            Profession: this.state.Profession,
            DateOfBirth: this.state.DateOfBirth,
            FullName: this.state.FullName,
            PhoneNumber:'+91'+this.state.PhoneNumber.substring(this.state.PhoneNumber.length - 10),
            EmailId: this.state.EmailId,
            Education: this.state.Education,
            SecondaryPhoneNumber:
                '+91' +
                this.state.SecondaryPhoneNumber.replace('+91', '').trim(),
            WhatsAppNumber: this.state.WhatsAppNumber
                ? '+91' + this.state.WhatsAppNumber.replace('+91', '').trim()
                : '',
            RegionalLanguage: this.state.RegionalLanguage,
            HouseNumber: this.state.HouseNumber,
            City: this.state.City,
            Area: this.state.Area,
            PinCode: this.state.PinCode,
            State: this.state.State,
            District: this.state.District,
            AadharNumber: this.state.AadharNumber,
            AccountNumber: this.state.AccountNumber,
            AccountHolderName: encodeURI(this.state.AccountHolderName),
            BankName: this.state.BankName,
            IFSCCode: this.state.IFSCCode,
            AccountType: this.state.AccountType,
            PanNumber: this.state.PanNumber,
            OldStatus: this.state.OldStatus,
            Status: this.state.Status
                ? this.state.Status
                : 'PENDING_VERIFICATION',
            RequestedTimeStamp: this.state.RequestedTimeStamp
                ? this.state.RequestedTimeStamp
                : dateFormatUtil(),
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin',
            profileDocId: this.state.profileDocId,
            UserRole: this.props.selectedUserRole,
            ValidateBankAccount: false,
            ValidatePANAccount: false
        };

        

        var validationResult = this.validateForm(data);

        if (validationResult.isError) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: validationResult.errorMsg
                });
            }
        } else {
            if (this._isMounted) {
                this.setState({ flag: true, alert: 0, alertMessage: '' });
            }
            
            RestServices.EditProfile(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                    
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 2,
                                alertMessage: 'Profile Updated...'
                            });
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        }
    };

    confirmDelete = () => {
        if (this._isMounted) {
            this.setState({ modalShow: true });
        }
    };

    deleteAllProfile = () => {
        if (this._isMounted) {
            this.deleteProfileNow(true);
        }
    };

    deleteProfile = () => {
        if (this._isMounted) {
            this.deleteProfileNow(false);
        }
    };

    deleteProfileNow = (deleteAllProfile) => {
        let postData = {
            UniqeID: this.props.UniqeID,
            UserType: this.props.selectedUserRole,
            deleteAllProfile: deleteAllProfile
        };

        

        RestServices.deleteProfileDetail(
            localStorage.getItem('FirebaseToken'),
            postData
        )
            .then((response) => response.json())
            .then((data) => {
                if (this._isMounted) {
                    this.setState({ modalShow: false });
                    window.location.reload();
                }

                if (data.error) {
                    if (this._isMounted) {
                        this.setState({ alert: 1, alertMessage: data.error });
                    }
                } else {
                    this.loadData();
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    };

    handleClose = () => {
        if (this._isMounted) {
            this.setState({ modalShow: false });
        }
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.flag && <Spinner animation="border" />}

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Status</Form.Label>

                        <select
                            className="form-control"
                            name="Status"
                            value={this.state.Status}
                            onChange={this.onChangeValues}
                        >
                            <option value="PENDING_VERIFICATION">
                                Verification Pending
                            </option>
                            <option value="Rejected">Rejected</option>
                            <option value="Approved">Approved</option>
                        </select>
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Aadhar Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="AadharNumber"
                            value={this.state.AadharNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            placeholder="Enter Full Name"
                            type="text"
                            name="FullName"
                            value={this.state.FullName}
                            onChange={this.onChangeValues}
                            required
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Date of Birth</Form.Label>
                        <Form.Control
                            placeholder="Enter Date of Birth"
                            max={this.state.maxDOB}
                            type="date"
                            name="DateOfBirth"
                            value={this.state.DateOfBirth}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Email Id</Form.Label>
                        <Form.Control
                            placeholder="Enter Email Id"
                            type="text"
                            name="EmailId"
                            value={this.state.EmailId}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Regional Language</Form.Label>
                        <Autocomplete
                            name="RegionalLanguage"
                            value={this.state.RegionalLanguage}
                            onChange={(event, newValue) => {
                                this.setState({ RegionalLanguage: newValue });
                            }}
                            id="user_profession"
                            options={this.state.AllRegionalLanguage.map(
                                (arr) => arr
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Education</Form.Label>
                        <Form.Control
                            placeholder="Enter Education"
                            type="text"
                            name="Education"
                            value={this.state.Education}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                            placeholder="Enter Mobile Number"
                            type="text"
                            name="PhoneNumber"
                            value={this.state.PhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Alternate Mobile Number</Form.Label>
                        <Form.Control
                            placeholder="Enter Alternate Mobile Number"
                            type="text"
                            name="SecondaryPhoneNumber"
                            value={this.state.SecondaryPhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>WhatsApp Number</Form.Label>
                        <Form.Control
                            placeholder="Enter WhatsApp Number"
                            type="text"
                            name="WhatsAppNumber"
                            value={this.state.WhatsAppNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Profession</Form.Label>
                        <Autocomplete
                            name="Profession"
                            value={this.state.Profession}
                            onChange={(event, newValue) => {
                                this.setState({ Profession: newValue });
                            }}
                            id="user_profession"
                            options={this.state.AllProfessions.map(
                                (arr) => arr
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

               

                <Row>
                    <Col>
                        <h5>Residential Address</h5>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>House Number</Form.Label>
                        <Form.Control
                            placeholder="Enter House Number"
                            type="text"
                            name="HouseNumber"
                            value={this.state.HouseNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Area</Form.Label>
                        <Form.Control
                            placeholder="Enter Area"
                            type="text"
                            name="Area"
                            value={this.state.Area}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            placeholder="Enter City/Town"
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Pin Code</Form.Label>
                        <Form.Control
                            placeholder="Enter Pin Code"
                            type="text"
                            name="PinCode"
                            value={this.state.PinCode}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>District</Form.Label>
                        <Form.Control
                            placeholder="Enter District"
                            type="text"
                            name="District"
                            value={this.state.District}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>

                        <Autocomplete
                            name="State"
                            value={this.state.State}
                            onChange={(event, newValue) => {
                                this.setState({ State: newValue });
                            }}
                            id="user_State"
                            options={this.state.AllStates.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

               
                <Row>
                    <Col>
                        <h5>Banking Details</h5>
                        <hr />
                    </Col>
                </Row>

                {this.state.Beneficiary && (
                    <div>
                        {this.state.Beneficiary.map((c, index) => {
                            let primaryBank = this.state.primaryBank;
                            if (c.isPrimary) {
                                primaryBank = c.beneId;
                            }

                            return (
                                <div key={index} id={index}>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>PAN Number</Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                name="PanNumber"
                                                value={c.PanNumber}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>
                                                Account Holder Name
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.AccountHolderName}
                                                name="AccountHolderName"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>Bank Name</Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.BankName}
                                                name="BankName"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>
                                                Account Number
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.AccountNumber}
                                                name="AccountNumber"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>IFSC Code</Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.IFSCCode}
                                                name="IFSCCode"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>

                                    <hr />
                                </div>
                            );
                        })}
                    </div>
                )}

                <Form.Row>
                    <Button
                        variant="primary"
                        type="submit"
                        onClick={this.editProfileData}
                    >
                        Update Profile
                    </Button>
                    {this.state.profileDocId && (
                        <Button
                            style={{ marginLeft: '1rem' }}
                            variant="primary"
                            type="submit"
                            onClick={this.confirmDelete}
                        >
                            Delete
                        </Button>
                    )}
                </Form.Row>

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Are you sure you want to delete?</p>

                        {this.state.AllRoles && this.state.AllRoles.length > 1 && (
                            <div>
                                {this.state.AllRoles.map((role) => (
                                    <p key={role}>{role} Profile</p>
                                ))}
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        {this.state.AllRoles && this.state.AllRoles.length > 1 && (
                            <div>
                                <Button
                                    variant="primary"
                                    onClick={this.deleteProfile}
                                >
                                    Delete {this.props.selectedUserRole}
                                </Button>
                                <Button
                                    style={{ marginLeft: '1rem' }}
                                    variant="primary"
                                    onClick={this.deleteAllProfile}
                                >
                                    Delete All
                                </Button>
                            </div>
                        )}
                        {this.state.AllRoles.length < 2 && (
                            <div>
                                <Button
                                    variant="primary"
                                    onClick={this.deleteAllProfile}
                                >
                                    Yes
                                </Button>
                            </div>
                        )}
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }

    validateAddForm = () => {};
    validateForm = () => {
        let isError = false;
        let errorMsg = '';
        if (this.state.FullName == '') {
            isError = true;
            errorMsg = errorMsg + ' Please enter Full Name.';
        }

        let PhoneNumber = this.state.PhoneNumber.replace('+91', '').trim();
        let SecondaryPhoneNumber = this.state.SecondaryPhoneNumber.replace(
            '+91',
            ''
        ).trim();

        PhoneNumber = PhoneNumber.replace('+91 ', '').trim();
        SecondaryPhoneNumber = SecondaryPhoneNumber.replace('+91 ', '').trim();

        if (PhoneNumber.length != 10 || !PhoneNumber.match('[0-9]{10}')) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Primary Phone Number.';
        }

        if (PhoneNumber == SecondaryPhoneNumber) {
            isError = true;
            errorMsg =
                errorMsg +
                ' Primary Number and Secondary Number cannot be the same.';
        }

        if (
            !/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/.test(this.state.AadharNumber)
        ) {
            // isError = true;
            // errorMsg = errorMsg + " Please enter valid Aadhar Number.";
        }

        if (
            !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                this.state.EmailId
            )
        ) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Personal EmailId.';
        }

        var reurndate = [];
        reurndate.isError = isError;
        reurndate.errorMsg = errorMsg;
        return reurndate;
    };
}

export default ViewProfile;
